import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import customers from './customers.js';
import globalLoader from '../site/global-loader.js';
import Listinput from './components/PNC/Listinput.js';

export default function PNCAssessment() {
  // Retrieve values if user cancelled at PNC's end
  const ifCancelled = document.getElementById('pnc-assessment').dataset
    .ifCancelled;
  let cancelData;

  if (ifCancelled.length > 0) {
    const ifCancelledJson = ifCancelled.replaceAll("'", '"');
    cancelData = JSON.parse(ifCancelledJson);
  }

  const [totalGallons, setTotalGallons] = useState(0);
  const [totalFee, setTotalFee] = useState(0);
  const [errors, setErrors] = useState({});
  const [pncForm, setPNCForm] = useState({
    odorID: cancelData ? cancelData.odor_id : '',
    firstName: cancelData ? cancelData.first_name : '',
    lastName: cancelData ? cancelData.last_name : '',
    email: cancelData ? cancelData.email : '',
    pncList: cancelData
      ? cancelData.pnc_list
      : [
          {
            id: 0,
            remPeriod: '',
            zipCode: '',
            remID: '',
            numGallons: 0,
            fee: 0
          }
        ],
    remittanceID: cancelData ? cancelData.post_id : 0
  });

  const [customer, setCustomer] = useState('');
  const customerList = customers;

  const [csvUploading, setcsvUploading] = useState(false);

  // sets customer name based on odorID
  const setCustomerName = async () => {
    if (pncForm.odorID) {
      const { odorID } = pncForm;

      globalLoader.show();
      const url = `/wp-admin/admin-ajax.php?action=post_get_customer_by_odorizer_id`;

      await axios
        .post(url, { odor_id: odorID })
        .then((res) => {
          const { customer } = res.data.data;
          if (customer) {
            let errorsToUpdate = { ...errors };
            delete errorsToUpdate['odorid'];
            setErrors({ ...errorsToUpdate });
            setCustomer(customer);
          }
        })
        .catch((err) => {
          globalLoader.hide();
          const { errors } = err.response.data.data;

          if (errors) {
            setCustomer('');
            setErrors((prevState) => ({ ...prevState, ...errors }));
          }
        });

      globalLoader.hide();
    }
  };

  // checks zip code and handles errors
  const setZipCodeError = async (id) => {
    if (pncForm.pncList[0]) {
      globalLoader.show();

      const { zipCode } = pncForm.pncList[id];
      const url = `/wp-admin/admin-ajax.php?action=post_check_zip_code`;

      await axios
        .post(url, { zip_code: zipCode, id: id })
        .then((res) => {
          let errorsToUpdate = { ...errors };
          delete errorsToUpdate[`zipCode${id}`];
          setErrors({ ...errorsToUpdate });
        })
        .catch((err) => {
          globalLoader.hide();
          const { errors } = err.response.data.data;

          if (errors) {
            setErrors((prevState) => ({ ...prevState, ...errors }));
          }
        });

      globalLoader.hide();
    }
  };

  const updateInput = (event, value) => {
    event.persist();
    let errorsToUpdate = { ...errors };
    delete errorsToUpdate[value];
    setErrors({ ...errorsToUpdate });
    setPNCForm((state) => ({
      ...state,
      [value]: event.target.value
    }));
  };

  // Update Gallons
  const updateTotalGallons = () => {
    let updateTotalGallons = 0;
    let errorsToUpdate = { ...errors };
    delete errorsToUpdate.totalFee;
    setErrors({ ...errorsToUpdate });
    pncForm.pncList.map((pnc) => {
      updateTotalGallons = pnc.numGallons + updateTotalGallons;
    });
    setTotalGallons(updateTotalGallons);
  };

  const isPNCListRowEmpty = ({ id, ...row }) => {
    let checkedValues = Object.values(row).map(
      (value) => value !== '' && value !== 0
    );
    return checkedValues.includes(true);
  };

  const deletePNCListRow = (event, id) => {
    // remove errors if any
    let errorsToUpdate = { ...errors };
    delete errorsToUpdate[`remPeriod${id}`];
    delete errorsToUpdate[`zipCode${id}`];
    delete errorsToUpdate[`remID${id}`];
    delete errorsToUpdate[`numGallons${id}`];
    setErrors({ ...errorsToUpdate });

    // remove row
    const row = event.target.closest('div').parentNode;
    row.style.transition = 'all 0.5s';
    row.style.opacity = '0';
    setTimeout(() => {
      let updatedPNCList = pncForm.pncList
        .filter((row) => row.id !== id)
        .map((row, id) => ({ ...row, id }));
      row.style.opacity = '1';
      setPNCForm({
        ...pncForm,
        pncList: updatedPNCList
      });
    }, 400);
  };

  const handleClearForm = () => {
    setErrors({});
    setPNCForm({
      ...pncForm,
      pncList: [
        {
          id: 0,
          remPeriod: '',
          zipCode: '',
          remID: '',
          numGallons: 0,
          fee: 0
        }
      ]
    });
  };

  const uploadCsvFile = async (event) => {
    event.persist();
    let url = `/wp-admin/admin-ajax.php?action=parse_remittance_csv_upload`;
    let formData = new FormData();

    // remove any errors
    let errorsToUpdate = { ...errors };
    delete errorsToUpdate.csv;
    setErrors(errorsToUpdate);

    setcsvUploading(true);
    formData.append('csv', event.target.files[0]);

    // clear out empties, reset IDs
    const pncList = pncForm.pncList
      .filter((row) => isPNCListRowEmpty(row))
      .map((row, id) => ({ ...row, id }));

    await axios
      .post(url, formData)
      .then((res) => {
        setcsvUploading(false);

        res.data.data.map((row) => {
          const numGallons = parseInt(row.numGallons);
          const calcFee = numGallons * 0.005;

          pncList.push({
            id: pncList.length,
            remPeriod: row.remPeriod,
            zipCode: row.zipCode,
            remID: row.remID,
            numGallons: numGallons,
            fee: Math.round((calcFee + Number.EPSILON) * 100) / 100
          });
        });

        setPNCForm((state) => ({ ...state, pncList }));
        setcsvUploading(false);
        event.target.value = '';
      })
      .catch((err) => {
        const { error } = err.response.data.data;
        setcsvUploading(false);
        const errorNotice = document.getElementById('errorNotice');

        errorNotice.scrollIntoView(false, {
          behavior: 'smooth'
        });

        if (error) {
          setErrors({ csv: error });
        }
        event.target.value = '';
      });
  };

  // Update Fee
  const updateTotalFee = () => {
    const calcTotalFee = totalGallons * 0.005;
    setTotalFee(Math.round((calcTotalFee + Number.EPSILON) * 100) / 100);
  };

  // Update Remittance Values
  const updateRemittanceValue = (pncID, keyName, newValue) => {
    const pncIndex = pncForm.pncList.findIndex((pnc) => pnc.id === pncID);
    let pnc = pncForm.pncList.find((pnc) => pnc.id === pncID);
    let newState = { ...pncForm };
    let errorsToUpdate = { ...errors };
    delete errorsToUpdate.form;

    switch (keyName) {
      case 'remPeriod':
        pnc = { ...pnc, [keyName]: newValue };
        delete errorsToUpdate['remPeriod' + pnc.id];
        break;
      case 'numGallons':
        if (Number.isNaN(parseInt(newValue))) {
          newValue = 0;
        }
        pnc = { ...pnc, [keyName]: parseInt(newValue) };
        const calcFee = parseInt(pnc.numGallons) * 0.005;
        pnc = {
          ...pnc,
          fee: Math.round((calcFee + Number.EPSILON) * 100) / 100
        };
        delete errorsToUpdate['numGallons' + pnc.id];
        break;
      case 'zipCode':
        pnc = { ...pnc, [keyName]: newValue };
        delete errorsToUpdate['zipCode' + pnc.id];
        break;
      case 'remID':
        pnc = { ...pnc, [keyName]: newValue };
        delete errorsToUpdate['remID' + pnc.id];
        break;
    }

    newState.pncList[pncIndex] = pnc;
    setPNCForm(newState);
    setErrors({ ...errorsToUpdate });
  };

  // Form Submit
  const handleSubmit = async () => {
    setErrors({});
    const completedPNCForm = {
      ...pncForm,
      totalGallons,
      totalFee
    };

    globalLoader.show();
    const url = `/wp-admin/admin-ajax.php?action=post_save_pnc_remittance`;

    await axios
      .post(url, completedPNCForm)
      .then((res) => {
        const { success } = res.data.data;
        if (success) {
          window.location.href = success;
        }
      })
      .catch((err) => {
        const { errors } = err.response.data.data;
        const errorNotice = document.getElementById('errorNotice');

        errorNotice.scrollIntoView(false, {
          behavior: 'smooth'
        });
        globalLoader.hide();

        if (errors) {
          setErrors(errors);
        }
      });
  };

  // Render PNC List
  const renderPNCList = () =>
    pncForm.pncList.map((pnc) => (
      <div className="grid pnc__table-item" key={pnc.id}>
        <Listinput
          classes="grid__col-xs-3"
          formErrors={errors}
          type="month"
          placeholder="YYYY-MM"
          pattern="[0-9]{4}-[0-9]{2}"
          pnc={pnc}
          keyName="remPeriod"
          onChange={(e) => {
            updateRemittanceValue(pnc.id, 'remPeriod', e.target.value);
          }}
        />
        <Listinput
          classes="grid__col-xs-3"
          formErrors={errors}
          placeholder="Zip Code or Postal Code"
          maxLength="5"
          pnc={pnc}
          keyName="zipCode"
          onChange={(e) => {
            updateRemittanceValue(pnc.id, 'zipCode', e.target.value);
          }}
          onBlur={(e) => {
            setZipCodeError(pnc.id, 'zipCode', e.target.value);
          }}
        />
        <Listinput
          classes="grid__col-xs-2"
         formErrors={errors}
          type="number"
          placeholder="ID Number"
          pnc={pnc}
          keyName="remID"
          onChange={(e) => {
            updateRemittanceValue(pnc.id, 'remID', e.target.value);
          }}
        />
        <Listinput
          classes="grid__col-xs-2"
          formErrors={errors}
          placeholder="Gallons"
          pnc={pnc}
          keyName="numGallons"
          onChange={updateRemittanceValue}
          onFocus={(event) => event.target.select()}
        />
        <div className="grid__col-xs-2 u--padding-left-0 u--padding-right-0">
          <label className="pnc__input">
            $
            {pnc.fee
              ? parseFloat(pnc.fee).toLocaleString('en-US', {
                  minimumFractionDigits: 2
                })
              : 0}
          </label>
        </div>
        <div className="pnc__table-item--trash">
          <i onClick={(event) => deletePNCListRow(event, pnc.id)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              height="25px"
              width="25px"
            >
              <path d="M135.2 17.69C140.6 6.848 151.7 0 163.8 0H284.2C296.3 0 307.4 6.848 312.8 17.69L320 32H416C433.7 32 448 46.33 448 64C448 81.67 433.7 96 416 96H32C14.33 96 0 81.67 0 64C0 46.33 14.33 32 32 32H128L135.2 17.69zM31.1 128H416V448C416 483.3 387.3 512 352 512H95.1C60.65 512 31.1 483.3 31.1 448V128zM111.1 208V432C111.1 440.8 119.2 448 127.1 448C136.8 448 143.1 440.8 143.1 432V208C143.1 199.2 136.8 192 127.1 192C119.2 192 111.1 199.2 111.1 208zM207.1 208V432C207.1 440.8 215.2 448 223.1 448C232.8 448 240 440.8 240 432V208C240 199.2 232.8 192 223.1 192C215.2 192 207.1 199.2 207.1 208zM304 208V432C304 440.8 311.2 448 320 448C328.8 448 336 440.8 336 432V208C336 199.2 328.8 192 320 192C311.2 192 304 199.2 304 208z" />
            </svg>
          </i>
        </div>
      </div>
    ));

  // Add Remittance to List
  const addPNC = () => {
    let updatedList = pncForm.pncList;
    updatedList.push({
      id: pncForm.pncList.length,
      zipCode: '',
      remID: '',
      numGallons: 0,
      fee: 0
    });
    setPNCForm((state) => ({ ...state, pncList: updatedList }));
  };

  useEffect(() => {
    updateTotalGallons();
  }, [pncForm]);

  useEffect(() => {
    updateTotalFee();
  }, [totalGallons]);

  return (
    <div id="pncremittance" className="container">
      <div id="errorNotice">
        {errors
          ? Object.values(errors).map((error, key) => (
              <div className="notice notice--error" key={key}>
                <p>
                  <span className="notice__title">Warning. </span>
                  {error}
                </p>
              </div>
            ))
          : ''}
      </div>

      <div className="grid">
        <div className="grid__col-xs-12 grid__col-md-6">
          <div className="form__field form__field--required">
            <label className="form__label">Odorizer ID Number </label>
            <span className="u--inline-block u--margin-left-10 u--font-weight-normal">
              {errors.customerName ? (
                <span className="error u--color-red">
                  {errors.customerName}
                </span>
              ) : (
                customer
              )}
            </span>
            <div
              className={`form__field form__field--required ${
                errors.odorid ? 'form__field--error' : ''
              }`}
            >
              <input
                type="text"
                className="form__input form__input--lg"
                placeholder="Odorizer ID Number"
                onChange={(event) => updateInput(event, 'odorID')}
                onBlur={setCustomerName}
                value={pncForm.odorID}
              />
            </div>
          </div>
        </div>

        <div className="grid__col-xs-6 grid__col-md-3 grid__col-lg-3">
          <div className="form__field form__field--required">
            <label className="form__label">First Name</label>
            <div
              className={`form__field form__field--required ${
                errors.firstName ? 'form__field--error' : ''
              }`}
            >
              <input
                type="text"
                className="form__input form__input--lg"
                placeholder="First Name"
                onChange={(event) => updateInput(event, 'firstName')}
                value={pncForm.firstName}
              />
            </div>
          </div>
        </div>

        <div className="grid__col-xs-6 grid__col-md-3 grid__col-lg-3">
          <div className="form__field form__field--required">
            <label className="form__label">Last Name</label>
            <div
              className={`form__field form__field--required ${
                errors.lastName ? 'form__field--error' : ''
              }`}
            >
              <input
                type="text"
                className="form__input form__input--lg"
                placeholder="Last Name"
                onChange={(event) => updateInput(event, 'lastName')}
                value={pncForm.lastName}
              />
            </div>
          </div>
        </div>

        <div className="grid__col-xs-12 grid__col-md-6">
          <div className="form__field form__field--required">
            <label className="form__label">Email</label>
            <div
              className={`form__field form__field--required ${
                errors.email ? 'form__field--error' : ''
              }`}
            >
              <input
                type="email"
                className="form__input form__input--lg"
                placeholder="Email"
                onChange={(event) => updateInput(event, 'email')}
                value={pncForm.email}
              />
            </div>
          </div>
        </div>
      </div>

      <p className="u--margin-bottom-20">
        To request a credit for previous overpayment, enter a negative (-)
        number of Odorized Gallons.
        <br />
        For credits which exceed your current assessment fee, this portal cannot
        currently accommodate your needs. Please contact{' '}
        <a href="mailto:remittance@propane.com">remittance@propane.com</a> for
        assistance.
      </p>
      <p>
        To import your fees via CSV, please use this{' '}
        <a
          href="https://cloudinary.propane.com/raw/upload/assessment-import-template_2025.csv"
          download
        >
          template
        </a>{' '}
        and select the import function below to upload this file.
      </p>

      <p
        className={`btn btn--blue btn--outline btn__file-upload ${
          csvUploading ? 'btn--loading' : ''
        }`}
      >
        <label className="btn__content">
          <span className="btn__text">Import CSV</span>
          <input
            type="file"
            accept=".csv"
            name="csv-import"
            onChange={uploadCsvFile}
            style={{ display: 'none' }}
          />
        </label>
      </p>

      {/* PNC Table */}
      <div className="container u--padding-left-20 u--padding-right-20">
        {/* PNC  Headers */}
        <div className="grid pnc__table-headers">
          <div className="grid__col-xs-3">Remittance Period</div>
          <div className="grid__col-xs-3">Terminal Zip or Postal Code</div>
          <div className="grid__col-xs-2">Remitter ID Number</div>
          <div className="grid__col-xs-2">Odorized Gallons</div>
          <div className="grid__col-xs-2">Assessment Fee</div>
        </div>
        {/* PNC List */}
        {renderPNCList()}
      </div>

      <div className="u--display-flex u--margin-top-30">
        {/* Add PNC Button */}
        <p className="u--margin-right-10">
          <button
            type="button"
            onClick={() => addPNC()}
            className="btn btn--blue btn--outline"
          >
            <span className="btn__content">
              <span className="btn__text">+ Add Row</span>
            </span>
          </button>
        </p>

        {/* Clear Remittance */}
        <p>
          <button
            type="button"
            onClick={() => handleClearForm()}
            className="btn btn--blue btn--outline"
          >
            <span className="btn__content">
              <span className="btn__text">Clear Form</span>
            </span>
          </button>
        </p>
      </div>

      {/* PNC Total Assessment */}
      <div className="container u--padding-left-20 u--padding-right-20">
        <div className="grid">
          <div className="grid__col-xs-2 grid__col-xs-offset-8">
            <label className="form__label">Total Odorized Gallons</label>
          </div>
          <div className="grid__col-xs-2">
            {' '}
            <label className="form__label">Total Assessment Fee</label>
          </div>
        </div>
        <div className="grid">
          <div className="grid__col-xs-2 grid__col-xs-offset-8 u--padding-left-0 u--padding-right-0">
            <label className="pnc__input pnc__input--total u--border-width-right-0">
              {totalGallons ? parseInt(totalGallons).toLocaleString() : 0} gal
            </label>
          </div>
          <div className="grid__col-xs-2 u--padding-left-0 u--padding-right-0 ">
            <label className="pnc__input pnc__input--total">
              $
              {parseFloat(totalFee).toLocaleString('en-US', {
                minimumFractionDigits: 2
              })}
            </label>
          </div>
        </div>
      </div>

      {/* Submit Form */}
      <div className="grid u--display-flex u--justify-content-center u--margin-top-35">
        <div className="grid__col-md-3 u--display-flex u--flex-direction-column u--justify-content-center u--padding-right-0 u--padding-left-0">
          <button
            onClick={() => {
              handleSubmit();
            }}
            type="submit"
            className="btn btn--block btn--primary"
            disabled={Object.keys(errors).length > 0} // if errors, disable submit
          >
            <span className="btn__content">
              <span className="btn__text">Submit & Pay</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
